export const DEFAULT_MINIMUM_PASSWORD_LENGTH = 8
export const MAXIMUM_PASSWORD_LENGTH = 100

export function resolveMinimumPasswordLength (value: unknown): number {
  const parsed = typeof value === 'number' ? value : Number(value)
  return Number.isInteger(parsed) &&
    parsed >= DEFAULT_MINIMUM_PASSWORD_LENGTH &&
    parsed <= MAXIMUM_PASSWORD_LENGTH
    ? parsed
    : DEFAULT_MINIMUM_PASSWORD_LENGTH
}

export function isValidMinimumPasswordLength (value: unknown): boolean {
  if (value === null || value === undefined || value === '') return true
  const parsed = Number(value)
  return Number.isInteger(parsed) &&
    parsed >= DEFAULT_MINIMUM_PASSWORD_LENGTH &&
    parsed <= MAXIMUM_PASSWORD_LENGTH
}
